import React, { useState } from "react";
import { MainContainer } from "./styles";
import { Box, Tab, Tabs } from "@mui/material";
import ProductCreation from "./ProductCreation";
import BulkLoading from "./BulkLoading";
import AddProductsOld from "../products/addProducts/Add";

const AddProducts = () => {
  const [value, setValue] = React.useState("creation");
  const [showNotification, setShowNotification] = useState()

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <MainContainer>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: "var(--pink-contentoh)" } }}
          aria-label="secondary tabs example"
          sx={{
            "& .MuiTab-root": {
              color: "var(--gray-contentoh)",
            },
            "& .Mui-selected": {
              color: "var(--pink-contentoh)",
            },
          }}
        >
          <Tab value="creation" label="Creación de productos" />
          {/*<Tab value="bulk" label="Carga masiva de información" />*/}
        </Tabs>
      </Box>
      {/* {value === "creation" && <ProductCreation />} */}
      {value === "creation" && <AddProductsOld setShowNotification={setShowNotification} />}
      {value === "bulk" && <BulkLoading />}
    </MainContainer>
  );
};

export default AddProducts;